import styled from 'styled-components';
interface BarProgressProps {
  color?: string;
  range?: number;
}

export const BarProgressContainer = styled.div<BarProgressProps>`

width: 100px;
height: 15px;
.move{
  width: ${props => props.range ? props.range * 100 : 0}%;
  background: ${props => props.color ? props.color : 'white'} 0% 0% no-repeat padding-box;
  height: 100%;
  border-radius: 18px;
}
`